import { computed, inject, type Ref } from 'vue'
import type { CustomCssVariables } from '../../types/custom-css'

export type GetConditionValueInject = (id: string, parentIndex?: number, parentId?: string) => boolean
export type GetStyleValueInject = (id: string, parentIndex?: number, parentId?: string) => CustomCssVariables

export default function useConditions(
    id: Ref<string>,
    parentIndex?: Ref<number | undefined>,
    parentId?: Ref<string | undefined>,
) {
    const getDisplayValue = inject<GetConditionValueInject>('getDisplayValue', () => true)
    const getDisableValue = inject<GetConditionValueInject>('getDisableValue', () => false)
    const getStyleValue = inject<GetStyleValueInject>('getStyleValue', () => ({}))

    const isDisplayed = computed(() => getDisplayValue(id.value, parentIndex?.value, parentId?.value))
    const isDisabled = computed(() => getDisableValue(id.value, parentIndex?.value, parentId?.value))
    const conditionalStyle = computed(() => getStyleValue(id.value, parentIndex?.value, parentId?.value))

    return {
        isDisplayed,
        isDisabled,
        conditionalStyle,
    }
}
